import { render, staticRenderFns } from "./DataEntryFields.vue?vue&type=template&id=f7bcaa2c&scoped=true&"
import script from "./DataEntryFields.vue?vue&type=script&lang=js&"
export * from "./DataEntryFields.vue?vue&type=script&lang=js&"
import style0 from "./DataEntryFields.vue?vue&type=style&index=0&id=f7bcaa2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bcaa2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7bcaa2c')) {
      api.createRecord('f7bcaa2c', component.options)
    } else {
      api.reload('f7bcaa2c', component.options)
    }
    module.hot.accept("./DataEntryFields.vue?vue&type=template&id=f7bcaa2c&scoped=true&", function () {
      api.rerender('f7bcaa2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ProductsPage/DataEntryFields.vue"
export default component.exports